import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { OtpModalModule } from '../otp-modal/otp-modal.module';
import { AddCardComponent } from './add-card.component';
import { I18nModule } from "@spartacus/core";
import { NgbPopover } from "@ng-bootstrap/ng-bootstrap";

@NgModule({
  declarations: [
      AddCardComponent
  ],
  exports:[
AddCardComponent
  ],

	imports: [
		CommonModule,
		ReactiveFormsModule,
		BrowserModule,
		FormsModule,
		OtpModalModule,
		I18nModule,
		NgbPopover

	],
  providers: [

  ],

})
export class AddCardModule {}
